console.log('🚀 main.tsx: Démarrage de l\'application');

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import './styles/imageEnhancements.css';

// Import du correctif Firebase
import './utils/firebaseFix';

// Import de l'application
import App from './App';

console.log('✅ Imports terminés');

// TEMP: Désactiver les service workers et purger les caches (évite mélange d'anciens chunks)
if ('serviceWorker' in navigator) {
  try {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        try { registration.unregister(); } catch {}
      });
      try { (window as any).caches?.keys?.().then((keys: string[]) => keys.forEach((k) => (window as any).caches.delete(k))); } catch {}
      console.log('SW désactivés et caches vidés');
    }).catch(() => {});
  } catch {}
}

// Rendu de l'application
const rootElement = document.getElementById('root');
console.log('Root element:', rootElement);

if (rootElement) {
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ Root créé');
    
    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    );
    console.log('✅ Application rendue');
  } catch (error) {
    console.error('❌ Erreur lors du rendu:', error);
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red; background: white;">
        <h1>Erreur de chargement</h1>
        <pre>${error}</pre>
      </div>
    `;
  }
} else {
  console.error('❌ Element root non trouvé!');
}
